import { useState } from 'react'

import { useMutation } from 'react-query'
import { toast } from 'react-toastify'
import { useTranslation } from 'react-i18next'
import {StoreCurrency} from '../../../../MyApi/sb/currency'


import PageHeader from '../../../../Components/UI/PageHeader'
import AddCurrency from "../../../../Components/sb/currency/currencyStore/addCurrency"


const CurrencyStore = () => {
const [currencyName ,setCurrencyName]= useState("")
const [currencySymbol ,setCurrencySymbol]= useState("")
const [currencyRate  ,setCurrencyRate]= useState("")
const [currencyDefault ,setCurrencyDefault]= useState(1)
const { i18n}=useTranslation()
const lang =i18n.language
  const mutation = useMutation(["addcurrency",lang],(postData)=>StoreCurrency(postData,lang),{
    onSuccess:(data)=>{
    toast.success(`${data.message}`)
    setCurrencyName("")
    setCurrencySymbol("")
    setCurrencyRate("")

    },
    onError:(error)=>{
    toast.error(`${error.response.data.message}`)
    }
  })

  const handlePostRequest =()=>{
    mutation.mutate({
      name:  currencyName,
      symbol: currencySymbol,
      rate:currencyRate,
      default:currencyDefault
    }) 
  }
  const isDisabled = () => {
   return !(currencyName && currencySymbol &&currencyRate ) 
  
}
  
  return (
    <div>
        <PageHeader title="إضافة عملات" saveButton={true} showBack={true} handlePostRequest={handlePostRequest} isdisbled={isDisabled}/>
        <AddCurrency setCurrencyName={setCurrencyName} setCurrencySymbol={setCurrencySymbol} setCurrencyRate={setCurrencyRate} setCurrencyDefault={setCurrencyDefault} currencyName={currencyName} currencySymbol={currencySymbol} currencyRate={currencyRate} currencyDefault={currencyDefault}/>
    </div>
  )
}

export default CurrencyStore